import { render, staticRenderFns } from "./EarningsReferrals.vue?vue&type=template&id=5ea66abc&scoped=true"
import script from "./EarningsReferrals.vue?vue&type=script&lang=js"
export * from "./EarningsReferrals.vue?vue&type=script&lang=js"
import style0 from "./EarningsReferrals.vue?vue&type=style&index=0&id=5ea66abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea66abc",
  null
  
)

export default component.exports